import { WebSocketChannelClient } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/WebSocketChannelClient";

// Receives Front-backed messaging events (KAM replies) for the current client user.
export default new WebSocketChannelClient("messaging");
